const _chaveSessionStorageCandidatura = 'candidaturaPendente';
export async function salvarCandidaturaPendente(vagaID, titulo, url, possivelmenteLogado) {
    try {
        if (localStorage.getItem(_chaveSessionStorageCandidatura)) {
            localStorage.removeItem(_chaveSessionStorageCandidatura);
        }

        
        const urlSemHost = url.replace(/https?:\/\/[^\/]+/, '');


        localStorage.setItem(_chaveSessionStorageCandidatura, JSON.stringify({ vagaID: vagaID, titulo: titulo, url: urlSemHost }));

        if (possivelmenteLogado) {
            let formData = new FormData();
            formData.append('vagaID', vagaID);
            await fetch(`/${CULTURE_EMPREGARE}/Vagas/SalvarCandidaturaPendente`, {
                method: 'POST',
                body: formData
            });
        }        

    } catch (e) {}
    
}
export function obterCandidaturaPendente() {
    try {
        const candidatura = localStorage.getItem(_chaveSessionStorageCandidatura);

        if (candidatura) {
            return JSON.parse(candidatura);
        }
    } catch (e) {

    }
    return { vagaID: "0" };
}
export async function removerCandidaturaPendente(possivelmenteLogado) {
    try {
        if (localStorage.getItem(_chaveSessionStorageCandidatura)) {
            localStorage.removeItem(_chaveSessionStorageCandidatura);           
            
        }
    } catch (e) {

    }
    
}